import React, { Fragment } from 'react';
import "./report-info.css";
import Spinner from "../../components/spinner/spinner-component";



const getDate = unixDate => {
  if (!unixDate) return 'No date'
  const date = new Date(unixDate);
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDay();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  return `${year}-${month}-${day}  ${hours}:${minutes}:${seconds}`
};


const ReportInfoComponent = (
  {
    title,
    dateCreated,
    dateDownloaded,
    loading,
    marginBottom,
    error
  }
  ) => {
  return (
    <div
      className="report_info shadow"
      style={{
        textAlign: loading ? 'center' : 'left',
        marginBottom: marginBottom ? '10px' : '0'
      }}
    >
      {
        error ?
          <span style={{alignSelf: 'center'}}>{ error }</span>
          :
          null
      }
      {
        !loading && !error ?
          (
            <Fragment>
              <div className="report_info__title_container">
                <h2 className="report_info__title_container__title" >{ title }</h2>
              </div>
              <div className="report_info__date_container">
                <div className="report_info__date_container__date">

                  <span style={{fontWeight: '400'}}>Date created: </span>
                  <span>{ dateCreated }</span>

                </div>
                <div className="report_info__date_container__date">

                  <span style={{fontWeight: '400'}}>Date downloaded: </span>
                  <span>{ getDate(dateDownloaded) }</span>

                </div>
              </div>
            </Fragment>
          )
          :
          <Spinner
            loading={loading}
          />
      }

    </div>
  )
};

export default ReportInfoComponent;


// WEBPACK FOOTER //
// ./src/modules/report-info/report-info-component.js